import axios from "axios";

import {HOST_URL, LOCAL_STORAGE_TOKEN_KEY} from "../../consts";
import {getRowsSuccess} from "./getRowsSuccessAction";
import {getRowsError} from "./getRowsErrorAction";
import {getRowsStarted} from "./getRowsStartedAction";
import {unauthorizedError} from "../signin/unauthorizedErrorAction";

export function getRows(projectId, search) {

    return function (dispatch) {
        let url = HOST_URL+'/api/panels?projectId=' + projectId;
        if (search)
            url += '&search='+search;

        let authToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        dispatch(getRowsStarted());

        return axios.get(url,{headers: {Authorization: authToken}}).then((response) => {
            if (response.data.success) {
                dispatch(getRowsSuccess(response.data.panelRows));
            }
            else {
                dispatch(getRowsError(new Error(response.data.message)));
            }
        }).catch(error => {
            if (error.response && error.response.status ===401)
                return dispatch(unauthorizedError());

            console.log(error.message);
            dispatch(getRowsError(error));
        });
    };
}